export const SUPPORT_DEPARTMENT_FINANCIAL = 'financial';
export const SUPPORT_DEPARTMENT_TECHNICAL = 'technical';
